import type { Icon, IconProps } from '@tabler/icons-react'
import dynamic from 'next/dynamic'

// Creates dynamic imports on demand for icons
// Prefer using the Icon directly but use this if we need to be generic
export const getIcon = (iconName: string, props?: IconProps) => {
  try {
    const Icon = dynamic(
      () =>
        import('@tabler/icons-react').then((mod) => {
          const IconComponent = mod[iconName as keyof typeof mod]
          return IconComponent as React.ComponentType<IconProps>
        }),
      {
        loading: () => <span />,
        ssr: false,
      }
    )

    return <Icon size={16} {...props} />
  } catch {
    console.error(`Failed to load icon: ${iconName}`)
    return null
  }
}

export const getIconAsIcon = (iconName: string): Icon => {
  try {
    // Return the component itself, not the rendered JSX
    return dynamic(
      () =>
        import('@tabler/icons-react').then((mod) => {
          const IconComponent = mod[iconName as keyof typeof mod]
          return IconComponent as React.ComponentType<IconProps>
        }),
      {
        loading: () => null,
        ssr: false,
      }
    ) as Icon
  } catch {
    console.error(`Failed to load icon: ${iconName}`)
    return null
  }
}
